import { Button, ButtonType, ModalFooter } from '@isbj-redesign/frontend-components'
import React, { FC } from 'react'

export type Props = {
    onClose(): void
}

const ModalActions: FC<Props> = ({ children, onClose }) => (
    <ModalFooter>
        <Button type={ButtonType.Reset} outline color="link" onClick={onClose} className="text-muted">
            Schließen
        </Button>
        {children}
    </ModalFooter>
)

export default ModalActions
